import AbstractApiModel from '@/models/abstracts/AbstractApiModel';
import doc from '@model-core/decorators/doc';
import PeriodModel from '@/models/entities/PeriodModel';
import TeamModel from '@/models/entities/TeamModel';
import { listPage } from '@/models/listPage';

/**
 * Compteurs d'une période pour une équipe (GET /period_team_summaries, lecture seule) : feuilles soumises de l'équipe
 * (« Demandes », dans l'équipe de leur appartenance, figée à la soumission) et leurs minutes, tenus par l'API. Lus par
 * le Dirigeant de la société et le manager de l'équipe ; period et team réduites à leur identité.
 */
export default class PeriodTeamSummaryModel extends AbstractApiModel {
  protected _path = '/period_team_summaries/{?id}';

  declare _tsFilters: { period?: id | id[]; team?: id | id[] };

  @doc.model(() => PeriodModel) declare period: PeriodModel;
  @doc.model(() => TeamModel) declare team: TeamModel;
  @doc.number declare timeSheetCount: number;
  @doc.number declare totalMinutes: number;
}

export interface PeriodTotals {
  timeSheetCount: number;
  totalMinutes: number;
}

/**
 * Totaux de ces équipes par période (Historique du manager : ses équipes), une requête pour les périodes données
 * (useRelatedByIds) : [periodId => somme des équipes]. Une période sans feuille de ces équipes vaut 0 / 0.
 */
export function teamTotalsLoader(teamIds: number[]) {
  return async (periodIds: string[]): Promise<Map<number, PeriodTotals>> => {
    const { models } = await listPage(PeriodTeamSummaryModel, {
      filters: { period: periodIds, team: teamIds.map(String) },
      page: 1,
      itemsPerPage: periodIds.length * teamIds.length,
      partial: true,
    });
    const totals = new Map(periodIds.map((id) => [Number(id), { timeSheetCount: 0, totalMinutes: 0 }]));
    for (const summary of models) {
      const total = totals.get(Number(summary.period.id));
      if (total) {
        total.timeSheetCount += summary.timeSheetCount;
        total.totalMinutes += summary.totalMinutes;
      }
    }
    return totals;
  };
}
